import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Tooltip, Button, Message, Spin, Popover} from 'antd';
import {DownloadOutlined} from '@ant-design/icons';
import {businessCardinfo} from '../../../actions/businessCard';
import {fetchCompanyDetail, fetchCompanyData} from '../../../actions/userCenterAction';
import {fetchV1Search} from '../../../actions/searchAction';
import iconTip from '../../../asset/img/icons/icon-tip.svg';
// import iconRefresh from '../../../asset/img/icons/icon-refresh.svg';
import iconUpRed from '../../../asset/img/icons/icon-up-red.svg';
import iconLine from '../../../asset/img/icons/icon-line.svg';
import iconDown from '../../../asset/img/icons/icon-down.svg';
import iconTel from '../../../asset/img/icons/icon-tel.svg';
import iconCircle from '../../../asset/img/icons/icon-circle.svg';
import iconHeart from '../../../asset/img/icons/icon-heart.svg';
import imgBusinessCardDemo from '../../../asset/img/userCenter/business-card-demo.png';
import iconEmpty from '../../../asset/img/icons/empty.png';
import PhoneCard from '../../preview/phoneCard';
import LandingPage from '../../preview/landingPage';
import {Chart} from '@antv/g2';
import {toPng} from 'html-to-image';
import {_request, formatTime} from '../../../util';
import secm from '@baidu/sec-monitor';
import './style.less';

// mock
// import {detail, data1, data2} from './config';
const downExcelUrl = '/api/v1/assessment/download?company=';
class MyAttestDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasMicroCard: false,
            landingPageDetail: {},
            companyDetail: {},
            companyData: {},
            loaded: false,
            empty: false,
            getDataStatus: true
        };
    }
    componentDidMount() {
        if (this.props?.userInfo.code !== 200) {
            this.login();
        } else {
            this.getData();
        }
    }
    getData = () => {
        const {company, fetchCompanyData, fetchCompanyDetail} = this.props;
        const getCompanyData = fetchCompanyData({company});
        const getCompanyDetail = fetchCompanyDetail({company: company});
        Promise.all([getCompanyData, getCompanyDetail]).then(res => {
            if (res[0].code === 200 && res[1].code === 200) {
                if (!res[0].data.card_detail || res[0].data.card_detail.length === 0) {
                    this.setState({
                        empty: true,
                        loaded: true
                    });
                    return;
                }
                this.formatData(res[0].data);
                this.getCompanyDetail(res[1].data);
            } else {
                this.setState({
                    empty: true,
                    loaded: true,
                    getDataStatus: false
                });
            }
        }).catch(err => {
            this.setState({
                empty: true,
                loaded: true,
                getDataStatus: false
            });
        });
    };
    formatData = (data) => {
        // 卡片页数据
        const cardChartInfo = [];
        const cardTotal = data.card_total;
        const cardPhoneInfo = data.card_phones;
        const cardDetailLen = data.card_detail.length;
        // 落地页数据
        const pageChartInfo = [];
        const pageTotal = data.page_total;
        const pagePhoneInfo = data.page_phones;
        const pageDetailLen = data.page_detail.length;
        let maxNum = 0;
        data.card_detail.map(item => {
            cardChartInfo.push({
                name: '月展示',
                date: item.date,
                value: item.view_cur
            });
            cardChartInfo.push({
                name: '月点击',
                date: item.date,
                value: item.click_cur,
                ratio: item.click_rate * 100,
                ratioText: '点击率'
            });
            cardChartInfo.push({
                name: '月拨打',
                date: item.date,
                value: item.tel_cur
            });
            if (item.view_cur > maxNum) {
                maxNum = item.view_cur;
            }
            if (item.tel_cur > maxNum) {
                maxNum = item.tel_cur;
            }
            return item;
        });
        data.page_detail.map(item => {
            pageChartInfo.push({
                name: '落地页月访问',
                date: item.date,
                value: item.view_cur
            });
            // pageChartInfo.push({
            //     name: '月拨打',
            //     date: item.date,
            //     value: item.tel_cur
            // });
            return item;
        });
        this.setState({
            companyData: {
                cardInfo: {
                    cardTotal,
                    cardChartInfo,
                    cardPhoneInfo,
                    prevMonthCardTotal: data.card_detail[cardDetailLen - 1] || {},
                    maxNum: maxNum
                },
                pageInfo: {
                    pageChartInfo,
                    pageTotal,
                    pagePhoneInfo,
                    prevMonthPageTotal: data.page_detail[pageDetailLen - 1] || {}
                }
            }
        }, this.initChart);
    };
    login = () => {
        const isPro = window.location.href.indexOf('haoma.baidu.com') > -1;
        const ele = document.createElement('a');
        ele.href = `https://passport${isPro ? '' : '.qatest'}.baidu.com/v2/?login&u=${
            encodeURIComponent(window.location.href)
        }`;
        ele.click();
    };
    initChart = () => {
        const {companyData = {}} = this.state;
        const cardChart = new Chart({
            container: 'card-chart-container',
            autoFit: true,
            height: 230,
        });
        const landPageChart = new Chart({
            container: 'land-page-chart-container',
            autoFit: true,
            height: 230,
        });
        this.updateCardCharts(cardChart, companyData.cardInfo?.cardChartInfo, companyData.cardInfo?.maxNum);
        this.updateLandPageCharts(landPageChart, companyData.pageInfo?.pageChartInfo);
    };
    getCompanyDetail = (data) => {
        const {company, businessCardInfo} = this.props;
        this.setState({
            companyDetail: data
        });
        // 存在企业简介
        const hasMicroCardFlag = data.company_introduction.length > 0;
        if (hasMicroCardFlag) {
            this.setState({
                hasMicroCard: true
            }, () => {
                businessCardInfo({
                    company_name: decodeURIComponent(company)
                }).then(res => {
                    const resp = res.data || {};
                    resp.detailed_loc = resp.detailed_loc && JSON.parse(resp.detailed_loc);
                    resp.open_info = resp.open_info && JSON.parse(resp.open_info);
                    resp.company_adverts = resp.company_adverts && resp.company_adverts.split(';');

                    this.setState({
                        landingPageDetail: resp,
                        loaded: true
                    });
                }).catch(() => this.setState({loaded: true}));
            });
            return;
        }
        this.searchFn();
    };
    searchFn = () => {
        const {company} = this.props;
        const searchInfo = decodeURIComponent(company) + '客服电话';
        const {fetchV1Search} = this.props;
        const fetchSearch = (json) => {
            fetchV1Search(json).then(data => {
                if (data.code === 200) {
                    let pageObj = {};
                    let key = Object.keys(data.data)[0];
                    let typeObj = data.data[key];

                    if (!Object.keys(data.data).length) {
                        this.setState({
                            loaded: true
                        });
                        return;
                    }

                    if (typeObj.customer) {
                        pageObj = typeObj.customer[0];
                    }
                    this.setState({
                        landingPageDetail: pageObj,
                        loaded: true
                    });
                } else {
                    this.setState({
                        loaded: true
                    });
                    Message.error({
                        content: data.message
                    });
                }
            }).catch(() => this.setState({loaded: true}));
        };
        _request(fetchSearch, {search: searchInfo});
    };
    updateLandPageCharts = (chart, data) => {
        chart.data(data);
        chart.scale('value', {
            nice: true,
        });
        chart.legend(false);
        chart.axis('value', true);
        chart.tooltip({
            showMarkers: false,
            shared: true,
        });

        chart
            .interval()
            .position('date*value')
            .color('name', val => {
                if (val === '落地页月访问') {
                    return '#8964FF';
                } else {
                    return '#2CD9C5';
                }
            })
            .adjust([
                {
                    type: 'dodge',
                    marginRatio: .3,
                },
            ]);

        chart.interaction('active-region');
        chart.render();
    };
    updateCardCharts = (chart, data, maxNum) => {
        const maxScale = (maxNum + 100 - maxNum % 100);
        chart.data(data);
        chart.scale({
            ratio: {
                min: 0,
                max: 100,
                formatter: (value) => {
                    return value ? value.toFixed(2) + '%' : '';
                }
            },
            value: {
                min: 0,
                max: maxScale,
                type: 'pow'
            }
        }, {
            nice: true,
        });
        chart.legend(false);
        chart.axis('ratio', {
            subTickLine: {
                count: 4
            },
            label: {
                formatter: (val) => {
                    let value = val || 0;
                    if (val) {
                        const dotIndex = val.indexOf('.');
                        value = val.substr(0, dotIndex);
                    }
                    return value + '%';
                }
            }
        });
        chart.axis('value', {
            subTickLine: {
                count: 4
            }
        });
        chart.tooltip({
            showMarkers: false,
            shared: true,
        });
        chart
            .interval()
            .position('date*value')
            .color('name', (val) => {
                if (val === '月展示') {
                    return '#3388FF';
                } else if (val === '月点击') {
                    return '#3FC1F7';
                } else {
                    return '#2CD9C5';
                }
            })
            .adjust([
                {
                    type: 'dodge',
                    marginRatio: .3,
                },
            ]);
        chart
            .line()
            .position('date*ratio')
            .color('ratioText', '#FF8040');
        // chart.point()
        //     .position('date*ratio')
        //     .color('ratioText', false);
        chart.interaction('active-region');
        chart.render();
    };
    downloadImg = () => {
        const {company} = this.props;
        const node = document.getElementById('user_center-download-img-wrapper');
        this.recordProxy('aliasMyAttest', 'download', decodeURIComponent(company));
        toPng(node).then(imgUrl => {
            const time = formatTime('yyyy/MM/dd', new Date().getTime());
            const ele = document.createElement('a');
            ele.href = imgUrl;
            ele.download = decodeURIComponent(company) + '百度安全号码认证报告' + time;
            ele.click();
        }).catch(error => {
            console.log(error, 4234);
        });
    };
    recordProxy = (at, ae, aa) => {
        _hmt.push(['_trackEvent', at, ae, aa]);
        secm.action(at, ae, aa);
    };
    downloadExcel = () => {
        const {company} = this.props;
        const companyName = decodeURIComponent(company);
        this.recordProxy('aliasMyAttest', 'download-excel', companyName);
        const ele = document.createElement('a');
        ele.href = downExcelUrl + companyName;
        ele.target = '_self';
        ele.click();
    };
    render() {
        const {
            companyDetail = {}, hasMicroCard,
            landingPageDetail = {}, companyData = {},
            loaded, empty, getDataStatus
        } = this.state;
        const {company} = this.props;
        const {cardInfo = {}, pageInfo = {}} = companyData || {};
        const {cardTotal = {}, cardPhoneInfo = [], prevMonthCardTotal = {}} = cardInfo;
        const {pageTotal = {}, pagePhoneInfo = [], prevMonthPageTotal = {}} = pageInfo;
        const Empty = (<div className="empty">
            <img src={iconEmpty} className="empty-img"></img>
            <p className="empty-text">{getDataStatus
                ? '当前企业数据还在收集中，认证满一个月后，将按月进行数据展示，请稍后查看' : '数据加载失败，请刷新页面'}
            </p>
        </div>);
        return (
            <div className="page-my-attest-detail">
                <Spin wrapperClassName="spin" tip="Loading..." spinning={!loaded} delay={100}>
                    {empty ? Empty : <>
                        <div className="page-header">
                            <div className="left">
                                <span className="page-title">我的认证</span>
                                <span className="company-name">{decodeURIComponent(company)}</span>
                                <Tooltip title={'仅支持按月展示企业认证数据情况'}>
                                    <img src={iconTip} className="tip-icon" />
                                </Tooltip>
                            </div>
                            <div className="right">
                                {/* <div className="reload-icon-wrapper" onClick={this.getData}>
                                    <img src={iconRefresh} className="reload-icon" />
                                </div> */}
                                <Button
                                    type="primary"
                                    shape="round"
                                    icon={<DownloadOutlined />}
                                    size={'normal'} onClick={this.downloadImg}>
                                    下载
                                </Button>
                            </div>
                        </div>
                        <div id="user_center-download-img-wrapper">
                            <div className="card-container">
                                <div className="title">
                                    <span className="text">卡片浏览趋势数据</span>
                                    <Tooltip title={'包含：电脑端，移动端所有客服认证号码卡的数据汇总情况'}>
                                        <img src={iconTip} className="tip-icon" />
                                    </Tooltip>
                                </div>
                                <div className="card-content">
                                    <div className="left-content">
                                        <PhoneCard detail={companyDetail}></PhoneCard>
                                    </div>
                                    <div className="right-content">
                                        <div className="card-list-wrapper">
                                            <div className="card-list">
                                                <div className="card-list-title">
                                                    <span className="text">累计展示</span>
                                                </div>
                                                <div className="card-list-info">
                                                    <span className="number blue">{cardTotal.view_total || '-'}</span>次
                                                </div>
                                                <div className="card-list-info">
                                                    <span className="data-info">
                                                        最近一个月展示：{prevMonthCardTotal.view_cur || 0}次
                                                    </span>
                                                    <div className={'trend ' + (cardTotal.view_ring > 0
                                                        ? 'up' : cardTotal.view_ring < 0 ? 'down' : '')}>
                                                        <img
                                                            src={cardTotal.view_ring > 0 ? iconUpRed
                                                                : cardTotal.view_ring < 0 ? iconDown : iconLine}
                                                            className="icon-trend"></img>
                                                        {cardTotal.view_ring ? Math.abs(cardTotal.view_ring) : 0}%
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-list">
                                                <div className="card-list-title">
                                                    <span className="text">累计点击</span>
                                                </div>
                                                <div className="card-list-info">
                                                    <span className="number light-blue">
                                                        {cardTotal.click_total || '-'}
                                                    </span>次
                                                </div>
                                                <div className="card-list-info">
                                                    <span className="data-info">
                                                        最近一个月点击：{prevMonthCardTotal.click_cur || 0}次
                                                    </span>
                                                    <div className={'trend ' + (cardTotal.click_ring > 0
                                                        ? 'up' : cardTotal.click_ring < 0 ? 'down' : '')}>
                                                        <img
                                                            src={cardTotal.click_ring > 0 ? iconUpRed
                                                                : cardTotal.click_ring < 0 ? iconDown : iconLine}
                                                            className="icon-trend"></img>
                                                        {cardTotal.click_ring ? Math.abs(cardTotal.click_ring) : 0}%
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-list">
                                                <div className="card-list-title">
                                                    <span className="text">累计拨打</span>
                                                </div>
                                                <div className="card-list-info">
                                                    <span className="number light-green">
                                                        {cardTotal.tel_total || '-'}
                                                    </span>次
                                                </div>
                                                <div className="card-list-info">
                                                    <span className="data-info">
                                                        最近一个月拨打：{prevMonthCardTotal.tel_cur}次
                                                    </span>
                                                    <div className={'trend ' + (cardTotal.tel_ring > 0
                                                        ? 'up' : cardTotal.tel_ring < 0 ? 'down' : '')}>
                                                        <img
                                                            src={cardTotal.tel_ring > 0 ? iconUpRed
                                                                : cardTotal.tel_ring < 0 ? iconDown : iconLine}
                                                            className="icon-trend"></img>
                                                        {cardTotal.tel_ring ? Math.abs(cardTotal.tel_ring) : 0}%
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-list">
                                                <div className="card-list-title">
                                                    <span className="text">累计上线</span>
                                                </div>
                                                <div className="card-list-info">
                                                    <span className="number">{cardTotal.time_total}</span>天
                                                </div>
                                            </div>
                                        </div>
                                        <div id="card-chart-container"></div>
                                        <div className="data-info-list-container">
                                            <p className="data-title">客服卡单个号码拨打数据</p>
                                            <div className="data-info-list-wrapper">
                                                {cardPhoneInfo.map(item => {
                                                    return (
                                                        <div className="data-info-list" key={item.phone}>
                                                            <div className="data-key">{item.phone}</div>
                                                            <div className="data-info">
                                                                <span className="data-text">累计拨打</span>
                                                                <span className="data-detail">{item.num || 0}</span>
                                                                <span className="data-text">次</span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                                {/* <div className="data-info-list">
                                                    <div className="data-key">18410086512</div>
                                                    <div className="data-info">
                                                        <span className="data-text">累计拨打</span>
                                                        <span className="data-detail">322</span>
                                                        <span className="data-text">次</span>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="land-page-info-container">
                                <div className="title">
                                    <span className="text">落地页浏览趋势数据</span>
                                    <Tooltip title={'包含：电脑端，移动端所有客服认证号码卡的数据汇总情况'}>
                                        <img src={iconTip} className="tip-icon" />
                                    </Tooltip>
                                </div>
                                <div className="card-content">
                                    <div className="left-content">
                                        <LandingPage hasMicroCard={hasMicroCard}
                                            landingPageDetail={landingPageDetail} />
                                    </div>
                                    <div className="right-content">
                                        <div className="card-list-wrapper">
                                            <div className="card-list">
                                                <div className="card-list-title">
                                                    <span className="text">落地页累计访问</span>
                                                </div>
                                                <div className="card-list-info">
                                                    <span className="number light-purple">
                                                        {pageTotal.view_total || '-'}
                                                    </span>次
                                                </div>
                                                <div className="card-list-info">
                                                    <span className="data-info">
                                                        最近一个月展示：{prevMonthPageTotal.view_cur || 0}次
                                                    </span>
                                                    <div className={'trend ' + (pageTotal.view_ring > 0
                                                        ? 'up' : pageTotal.view_ring < 0 ? 'down' : '')}>
                                                        <img
                                                            src={pageTotal.view_ring > 0 ? iconUpRed
                                                                : pageTotal.view_ring < 0 ? iconDown : iconLine}
                                                            className="icon-trend"></img>
                                                        {pageTotal.view_ring ? Math.abs(pageTotal.view_ring) : 0}%
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-list">
                                                <div className="card-list-title">
                                                    <span className="text">平均时间</span>
                                                </div>
                                                <div className="card-list-info">
                                                    <span className="number">{pageTotal.time_cur || 0}</span>分钟
                                                </div>
                                            </div>
                                            {/* <div className="card-list">
                                                <div className="card-list-title">
                                                    <span className="text">累计拨打</span>
                                                </div>
                                                <div className="card-list-info">
                                                    <span className="number light-green">
                                                        {pageTotal.tel_total || '-'}
                                                    </span>次
                                                </div>
                                                <div className="card-list-info">
                                                    <span className="data-info">
                                                        最近一个月拨打：{prevMonthPageTotal.tel_cur || '-'}次
                                                    </span>
                                                    <div className={'trend ' + (pageTotal.time_cur > 0
                                                        ? 'up' : pageTotal.time_cur < 0 ? 'down' : '')}>
                                                        <img
                                                            src={pageTotal.time_cur > 0 ? iconUpRed
                                                                : pageTotal.time_cur < 0 ? iconDown : iconLine}
                                                            className="icon-trend"></img>
                                                        {pageTotal.time_cur || '-'}%
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                        <div id="land-page-chart-container"></div>
                                        <div className="data-info-list-container">
                                            <p className="data-title">落地页单个号码拨打数据</p>
                                            <div className="data-info-list-wrapper">
                                                {pagePhoneInfo.map(item => {
                                                    return (
                                                        <div className="data-info-list" key={item.phone}>
                                                            <div className="data-key">{item.phone}</div>
                                                            <div className="data-info">
                                                                <span className="data-text">累计拨打</span>
                                                                <span className="data-detail">{item.num || 0}</span>
                                                                <span className="data-text">次</span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                                {/* <div className="data-info-list">
                                                    <div className="data-key">18410086512</div>
                                                    <div className="data-info">
                                                        <span className="data-text">累计拨打</span>
                                                        <span className="data-detail">322</span>
                                                        <span className="data-text">次</span>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="data-latitude-info">
                                            <div className="info-list">
                                                <div className="info-list-title">累计评价</div>
                                                <div className="info download">
                                                    <span className="text">{pageTotal.total_review || 0}</span>
                                                    <span className="unit">次</span>
                                                    {pageTotal.total_review > 0
                                                        && <DownloadOutlined
                                                            className="icon-download"
                                                            onClick={this.downloadExcel}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className="info-list">
                                                <div className="info-list-title">
                                                    <img src={iconTel} className="icon"></img>
                                                    <span>服务接通好评率</span>
                                                </div>
                                                <div className="info">
                                                    <span className="text">{pageTotal.service_on || 0}%</span>
                                                </div>
                                            </div>
                                            <div className="info-list">
                                                <div className="info-list-title">
                                                    <img src={iconCircle} className="icon"></img>
                                                    <span>号码准确好评率</span>
                                                </div>
                                                <div className="info">
                                                    <span className="text">{pageTotal.right_phone || 0}%</span>
                                                </div>
                                            </div>
                                            <div className="info-list">
                                                <div className="info-list-title">
                                                    <img src={iconHeart} className="icon"></img>
                                                    <span>服务质量好评率</span>
                                                </div>
                                                <div className="info">
                                                    <span className="text">{pageTotal.good_job || 0}%</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="data-latitude-info">
                                            <div className="info-list">
                                                <div className="info-list-title">点击官网</div>
                                                <div className="info">
                                                    <span className="text">{pageTotal.click_website || 0}</span>
                                                    <span className="unit">次</span>
                                                </div>
                                            </div>
                                            <div className="info-list">
                                                <div className="info-list-title">
                                                    <span>点击地址</span>
                                                </div>
                                                <div className="info">
                                                    <span className="text">{pageTotal.click_addr || 0}</span>
                                                    <span className="unit">次</span>
                                                </div>
                                            </div>
                                            <div className="info-list">
                                                <div className="info-list-title">
                                                    <span>点击在线客服</span>
                                                </div>
                                                <div className="info">
                                                    <span className="text">{pageTotal.click_service || 0}</span>
                                                    <span className="unit">次</span>
                                                </div>
                                            </div>
                                            {!hasMicroCard && <div className="info-list">
                                                <Popover
                                                    // trigger="click"
                                                    content={<img src={imgBusinessCardDemo} />}>
                                                    <p className="show-business-card-demo">开通企业简介，增加用户了解企业机会</p>
                                                </Popover>
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>}
                </Spin>
            </div>
        );
    }
}
MyAttestDetail.propTypes = {
    history: PropTypes.any,
    userInfo: PropTypes.any,
    businessCardInfo: PropTypes.func,
    fetchCompanyDetail: PropTypes.func,
    fetchV1Search: PropTypes.func,
    fetchCompanyData: PropTypes.func,
    company: PropTypes.string
};

function mapDispatchToProps(dispatch) {
    return {
        businessCardInfo: obj => businessCardinfo(dispatch, obj),
        fetchV1Search: (type, obj) => fetchV1Search(dispatch, type, obj),
        fetchCompanyDetail: obj => fetchCompanyDetail(dispatch, obj),
        fetchCompanyData: obj => fetchCompanyData(dispatch, obj)
    };
}

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MyAttestDetail));
